export default {
    GET_ITEMS(state) {
        return state.items;
    },
    GET_ACTION_STATUS(state) {
        return state.actionStatus;
    },
}